import {
  REHYDRATE
} from 'redux-persist';
import update from 'immutability-helper';
import {
  LOGOUT
} from 'actions/loginStateActions';
import {
  ANY_FIELD_ADD,
  ANY_FIELD_UPDATE,
  FORMFIELD_UPDATE,
  ANY_FIELD_REMOVE,
  CLONE_OBJECT,
  addNestedFields,
  removeNestedFields,
  updatedObject,
  getObject,
} from 'actions/formActions';
import addKey from 'store/factories/addKey';
import {
  ADMIN_INSPECTION_JOB_INIT,
  ADMIN_INSPECTION_JOB_FETCH_BEGIN,
  ADMIN_INSPECTION_JOB_FETCH_SUCCESS,
  ADMIN_INSPECTION_JOB_FETCH_FAIL,
  ADMIN_INSPECTION_QUOTE_FETCH_BEGIN,
  ADMIN_INSPECTION_QUOTE_FETCH_SUCCESS,
  ADMIN_INSPECTION_QUOTE_FETCH_FAIL,
  ADMIN_INSPECTION_QUOTE_SUBMIT_BEGIN,
  ADMIN_INSPECTION_QUOTE_SUBMIT_SUCCESS,
  ADMIN_INSPECTION_QUOTE_PUBLISH_SUCCESS,
  ADMIN_INSPECTION_QUOTE_SUBMIT_FAIL,
  ADMIN_INSPECTION_QUOTE_DELETE_BEGIN,
  ADMIN_INSPECTION_QUOTE_DELETE_SUCCESS,
  ADMIN_INSPECTION_QUOTE_DELETE_FAIL,
  ADMIN_INSPECTION_STATUS_UPDATE_BEGIN,
  ADMIN_INSPECTION_STATUS_UPDATE_SUCCESS,
  ADMIN_INSPECTION_STATUS_UPDATE_FAIL,
  ADMIN_INSPECTION_JOB_UPDATE_BEGIN,
  ADMIN_INSPECTION_JOB_UPDATE_SUCCESS,
  ADMIN_INSPECTION_JOB_UPDATE_FAIL,
  ADMIN_INSPECTION_JOB_RESET,
  ADMIN_INSPECTION_INVOICE_DOWNLOAD_BEGIN,
  ADMIN_INSPECTION_INVOICE_DOWNLOAD_SUCCESS,
  ADMIN_INSPECTION_INVOICE_DOWNLOAD_FAIL,
  ADMIN_INSPECTION_INVOICE_CREATE_BEGIN,
  ADMIN_INSPECTION_INVOICE_CREATE_SUCCESS,
  ADMIN_INSPECTION_INVOICE_CREATE_FAIL,
  ADMIN_INSPECTION_INVOICES_FETCH_BEGIN,
  ADMIN_INSPECTION_INVOICES_FETCH_SUCCESS,
  ADMIN_INSPECTION_INVOICES_FETCH_FAIL,
  ADMIN_INSPECTION_INVOICE_FETCH_BEGIN,
  ADMIN_INSPECTION_INVOICE_FETCH_SUCCESS,
  ADMIN_INSPECTION_INVOICE_FETCH_FAIL,
  ADMIN_INSPECTION_INVOICE_UPDATE_BEGIN,
  ADMIN_INSPECTION_INVOICE_UPDATE_SUCCESS,
  ADMIN_INSPECTION_INVOICE_UPDATE_FAIL,
  ADMIN_INSPECTION_INVOICE_DELETE_BEGIN,
  ADMIN_INSPECTION_INVOICE_DELETE_SUCCESS,
  ADMIN_INSPECTION_INVOICE_DELETE_FAIL,
} from './types';
import INITIAL_STATE from './state';

const getTabData = (inspectionInvoiceAddresses, inspectionFactory) => {
  const getRawInfo = (type) => inspectionInvoiceAddresses.find((e) => e.type === type);

  const supplier = getRawInfo('supplierInfo');
  const buyer = getRawInfo('buyerInfo');

  return {
    inspectionFactory,
    supplier,
    buyer,
  };
};

export default function adminInspectionJobWorkspaceReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case REHYDRATE:
      return state;

    case ADMIN_INSPECTION_JOB_INIT:
      return {
        data: INITIAL_STATE.data, status: 'initialized'
      };

    case ANY_FIELD_UPDATE: {
      if (action.storeName !== 'adminInspectionWorkspace') return state;

      return {
        ...state,
        data: updatedObject(state.data, action.accessPath, action.newVal),
        isChanged: true,
      };
    }

    case ANY_FIELD_ADD: {
      if (action.storeName !== 'adminInspectionWorkspace') return state;

      return {
        ...state,
        data: addNestedFields(state.data, action.accessPath, action.newObj),
        isChanged: true,
      };
    }

    case ANY_FIELD_REMOVE:
      if (action.storeName !== 'adminInspectionWorkspace') return state;

      return {
        ...state,
        data: removeNestedFields(state.data, action.accessPath),
          isChanged: true,
      };

    case CLONE_OBJECT: {
      if (action.storeName !== 'adminInspectionWorkspace') return state;

      const cloneObject = getObject(state.data, action.accessPath, action.idx);

      return {
        ...state,
        data: addNestedFields(state.data, action.accessPath, cloneObject)
      };
    }

    case FORMFIELD_UPDATE:
      if (action.storeName !== 'adminInspectionWorkspace') return state;

      return Object.assign({}, state, {
        data: {
          ...state.data,
          [action.fieldName]: action.newVal
        },
        isChanged: true,
      });

      // *******************************
      //        JOB FETCH
      // *******************************
    case ADMIN_INSPECTION_JOB_FETCH_BEGIN: {
      return Object.assign({}, state, {
        status: 'fetching'
      });
    }

    case ADMIN_INSPECTION_JOB_FETCH_SUCCESS:
      return update(state, {
        data: {
          $merge: {
            ...action.data,
            ...getTabData(action.data.inspectionInvoiceAddresses, action.data.inspectionFactory),
            inspectionServiceProviderMaps: action.data.inspectionServiceProviderMaps &&
              action.data.inspectionServiceProviderMaps.map((e) => ({
                label: e.serviceProvider.name,
                value: e.serviceProviderId,
              })),
            inspectionQuotes: action.data.inspectionQuotes.map(addKey)
          },
        },
        status: {
          $set: 'editing'
        },
      });

    case ADMIN_INSPECTION_JOB_FETCH_FAIL:
      return {
        ...state, status: 'failed', reason: action.reason
      };

      // *******************************
      //        QUOTATION FETCH
      // *******************************
    case ADMIN_INSPECTION_QUOTE_FETCH_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case ADMIN_INSPECTION_QUOTE_FETCH_SUCCESS:
      return Object.assign({}, state, {
        status: 'completed',
      });

    case ADMIN_INSPECTION_QUOTE_FETCH_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //        QUOTATION CREATION
      // *********************************
    case ADMIN_INSPECTION_QUOTE_SUBMIT_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case ADMIN_INSPECTION_QUOTE_SUBMIT_SUCCESS:
      return Object.assign({}, state, {
        status: 'editing',
      });

    case ADMIN_INSPECTION_QUOTE_PUBLISH_SUCCESS:
      return Object.assign({}, state, {
        status: 'editing',
      });

    case ADMIN_INSPECTION_QUOTE_SUBMIT_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });
      // *********************************
      //      QUOTATION DELETE
      // *********************************

    case ADMIN_INSPECTION_QUOTE_DELETE_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case ADMIN_INSPECTION_QUOTE_DELETE_SUCCESS:
      return update(state, {
        data: {
          inspectionQuotes: {
            $set: state.data.inspectionQuotes.filter((quote) => quote.id !== action.quoteId),
          },
        },
        status: {
          $set: 'editing'
        },
      });

    case ADMIN_INSPECTION_QUOTE_DELETE_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //      QUOTATION STATUS UPDATE
      // *********************************
    case ADMIN_INSPECTION_STATUS_UPDATE_BEGIN:
      return Object.assign({}, state, {
        status: 'updating',
      });

    case ADMIN_INSPECTION_STATUS_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        status: 'editing',
      });

    case ADMIN_INSPECTION_STATUS_UPDATE_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //      INVOICE DOWNLOAD POST
      // *********************************
    case ADMIN_INSPECTION_INVOICE_DOWNLOAD_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case ADMIN_INSPECTION_INVOICE_DOWNLOAD_SUCCESS:
      return Object.assign({}, state, {
        status: 'completed',
      });

    case ADMIN_INSPECTION_INVOICE_DOWNLOAD_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //      INVOICE CREATE POST
      // *********************************
    case ADMIN_INSPECTION_INVOICE_CREATE_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case ADMIN_INSPECTION_INVOICE_CREATE_SUCCESS:
      return Object.assign({}, state, {
        status: 'editing',
      });

    case ADMIN_INSPECTION_INVOICE_CREATE_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //      INVOICES FETCH GET
      // *********************************
    case ADMIN_INSPECTION_INVOICES_FETCH_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case ADMIN_INSPECTION_INVOICES_FETCH_SUCCESS:
      return ({
        data: {
          ...state.data,
          inspectionInvoices: action.inspectionInvoices
        },
        status: 'completed'
      });

    case ADMIN_INSPECTION_INVOICES_FETCH_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //      INVOICE FETCH GET
      // *********************************
    case ADMIN_INSPECTION_INVOICE_FETCH_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case ADMIN_INSPECTION_INVOICE_FETCH_SUCCESS:
      return ({
        data: {
          ...state.data,
          inspectionInvoice: action.inspectionInvoice
        },
        status: 'completed'
      });

    case ADMIN_INSPECTION_INVOICE_FETCH_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //      INVOICE UPDATE PUT
      // *********************************
    case ADMIN_INSPECTION_INVOICE_UPDATE_BEGIN:
      return Object.assign({}, state, {
        status: 'updating',
      });

    case ADMIN_INSPECTION_INVOICE_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        status: 'editing',
      });

    case ADMIN_INSPECTION_INVOICE_UPDATE_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //      INVOICE DELETE
      // *********************************
    case ADMIN_INSPECTION_INVOICE_DELETE_BEGIN:
      return Object.assign({}, state, {
        status: 'submitting',
      });

    case ADMIN_INSPECTION_INVOICE_DELETE_SUCCESS:
      return update(state, {
        data: {
          inspectionInvoices: {
            $set: state.data.inspectionInvoices.filter((invoice) => invoice.id !== action.invoiceId),
          },
        },
        status: {
          $set: 'editing'
        },
      });

    case ADMIN_INSPECTION_INVOICE_DELETE_FAIL:
      return Object.assign({}, state, {
        status: 'failed',
        failReason: action.reason,
      });

      // *********************************
      //      JOB UPDATE
      // *********************************
    case ADMIN_INSPECTION_JOB_UPDATE_BEGIN:
      return Object.assign({}, state, {
        status: 'updating',
      });

    case ADMIN_INSPECTION_JOB_UPDATE_SUCCESS:
      return Object.assign({}, state, {
        status: 'editing',
      });

    case ADMIN_INSPECTION_JOB_UPDATE_FAIL:
      return {
        ...state,
        status: 'failed',
          failReason: action.reason,
      };

    case ADMIN_INSPECTION_JOB_RESET:
    case LOGOUT:
      return INITIAL_STATE;

    default:
      return state;
  }
}